import Head from "next/head";
import { getRobotsMetaContent } from "utils/utils";

const KebijakanPrivasiSEO: React.FC = () => (
  <Head>
    <title>Kebijakan Privasi - CoLearn</title>
    <meta property="og:title" content="Kebijakan Privasi - CoLearn" />
    <meta
      property="og:image"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/share-og.jpg`}
    />
    <meta
      property="og:site_name"
      content="Aplikasi Belajar Online: Matematika, Fisika, Kimia | CoLearn"></meta>
    <meta
      property="og:url"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/kebijakan-privasi`}
    />
    <meta name="robots" content={getRobotsMetaContent()} />
    <link
      rel="canonical"
      href={`${process.env.NEXT_PUBLIC_SITE_URL}/kebijakan-privasi`}
    />
  </Head>
);

const KetentuanLayananSEO: React.FC = () => (
  <Head>
    <title>Ketentuan Layanan - CoLearn</title>
    <meta property="og:title" content="Ketentuan Layanan - CoLearn" />
    <meta
      property="og:image"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/share-og.jpg`}
    />
    <meta
      property="og:site_name"
      content="Aplikasi Belajar Online: Matematika, Fisika, Kimia | CoLearn"></meta>
    <meta
      property="og:url"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/ketentuan-layanan`}
    />
    <meta name="robots" content={getRobotsMetaContent()} />
    <link
      rel="canonical"
      href={`${process.env.NEXT_PUBLIC_SITE_URL}/ketentuan-layanan`}
    />
  </Head>
);

const KetentuanPengembalianDanaSEO: React.FC = () => (
  <Head>
    <title>Ketentuan Pengembalian Dana - CoLearn</title>
    <meta property="og:title" content="Ketentuan Pengembalian Dana - CoLearn" />
    <meta
      property="og:image"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/share-og.jpg`}
    />
    <meta
      property="og:site_name"
      content="Aplikasi Belajar Online: Matematika, Fisika, Kimia | CoLearn"></meta>
    <meta
      property="og:url"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/garansi-uang-kembali`}
    />
    <meta name="robots" content={getRobotsMetaContent()} />
    <link
      rel="canonical"
      href={`${process.env.NEXT_PUBLIC_SITE_URL}/garansi-uang-kembali`}
    />
  </Head>
);

export {
  KebijakanPrivasiSEO,
  KetentuanLayananSEO,
  KetentuanPengembalianDanaSEO
};
// attempt to trigger build
